/* eslint-disable max-len,key-spacing */
/* global __AZURE_TENANT, __AZURE_CLIENT_ID, __AZURE_AUTHEN_URL , __AZURE_REDIRECT_URI */
import moment from 'moment';

export default function configure(
  $httpProvider,
  $compileProvider,
  $qProvider,
  $cookiesProvider,
  $mdAriaProvider,
  $mdThemingProvider,
  momentPickerProvider,
  adalAuthenticationServiceProvider
) {
  // TODO: Look into removing the need for this
  $qProvider.errorOnUnhandledRejections(false);

  _disableAjaxCaching($httpProvider);

  $mdAriaProvider.disableWarnings();

  // TODO: Remove this and convert whole app to use $onInit()
  $compileProvider.preAssignBindingsEnabled(true);

  _initMaterialThemes($mdThemingProvider);

  // _setCookieOptionsDefaults($cookiesProvider);

  momentPickerProvider.options({
    today: true,
    keyboard: true,
    minView: 'year',
    maxView: 'month',
    format: 'L',
  });

  const endpoints = {

    // Map the location of a request to an API to a the identifier of the associated resource
    // "Enter the root location of your To Go API here, e.g. https://contosotogo.azurewebsites.net/":
    // "Enter the App ID URI of your To Go API here, e.g. https://contoso.onmicrosoft.com/ToGoAPI",
  };

  adalAuthenticationServiceProvider.init(
    {
      instance: __AZURE_AUTHEN_URL,
      tenant: __AZURE_TENANT,
      clientId: __AZURE_CLIENT_ID,
      // tenant: 'hostcomply.onmicrosoft.com',
      // clientId: '74fe2591-6762-43c2-a813-d0656b52d97e',
      redirectUri: __AZURE_REDIRECT_URI,
      extraQueryParameter: 'nux=1',
      endpoints,
      cacheLocation: 'localStorage', // enable this for IE, as sessionStorage does not work for localhost.
      // Also, token acquisition for the To Go API will fail in IE when running on localhost, due to IE security restrictions.
    },
    $httpProvider,
  );

  console.log('app.config executed (app is configured)');
}

configure.$inject = [
  '$httpProvider',
  '$compileProvider',
  '$qProvider',
  '$cookiesProvider',
  '$mdAriaProvider',
  '$mdThemingProvider',
  'momentPickerProvider',
  'adalAuthenticationServiceProvider'
];


/* PRIVATE FUNCTIONS ************************ */

// Found here: https://stackoverflow.com/questions/16098430/angular-ie-caching-issue-for-http
function _disableAjaxCaching($httpProvider) {
  // initialize get if not there
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }

  // Answer edited to include suggestions from comments
  // because previous version of code introduced browser-related errors

  // disable IE ajax request caching
  $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
  // extra
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get.Pragma = 'no-cache';
}

function _initMaterialThemes($mdThemingProvider) {
  const customPrimary = {
    default: '400',
    50: '#62deff',
    100: '#49d8ff',
    200: '#2fd3ff',
    300: '#16ceff',
    400: '#00c6fb',
    500: '#8A0A59',
    600: '#009ec8',
    700: '#008aaf',
    800: '#007695',
    900: '#00627c',
    A100: '#7ce3ff',
    A200: '#95e9ff',
    A400: '#afeeff',
    A700: '#251759',
    contrastDefaultColor: 'light',
  };
  const customAccent = {
    default: '600',
    50: '#663400',
    100: '#804200',
    200: '#994f00',
    300: '#b35c00',
    400: '#cc6900',
    500: '#e67600',
    600: '#ff8f1a',
    700: '#ff9c33',
    800: '#ffa84d',
    900: '#ffb566',
    A100: '#ff8f1a',
    A200: '#8a0a59',
    A400: '#e67600',
    A700: '#8a0a59',
    contrastDefaultColor: 'light',
  };
  const customWarn = {
    default: '500',
    50: '#fbb4af',
    100: '#f99d97',
    200: '#f8877f',
    300: '#f77066',
    400: '#f55a4e',
    500: '#F44336',
    600: '#f32c1e',
    700: '#ea1c0d',
    800: '#d2190b',
    900: '#ba160a',
    A100: '#fccbc7',
    A200: '#fde1df',
    A400: '#fff8f7',
    A700: '#a21309',
    contrastDefaultColor: 'light',
  };
  const customBackground = {
    default: '100',
    50: '#ffffff',
    100: '#e8e8e8',
    200: '#dbdbdc',
    300: '#cececf',
    400: '#c1c1c3',
    500: '#b4b4b6',
    600: '#a7a7a9',
    700: '#9a9a9d',
    800: '#8d8d90',
    900: '#808084',
    A100: '#ffffff',
    A200: '#ffffff',
    A400: '#ffffff',
    A700: '#747477',
  };
  $mdThemingProvider.definePalette('customPrimary', customPrimary);
  $mdThemingProvider.definePalette('customAccent', customAccent);
  $mdThemingProvider.definePalette('customWarn', customWarn);
  $mdThemingProvider.definePalette('customBackground', customBackground);
  $mdThemingProvider.theme('default')
    .primaryPalette('customPrimary')
    .accentPalette('customAccent')
    .warnPalette('customWarn')
    .backgroundPalette('customBackground');
}

function _setCookieOptionsDefaults($cookiesProvider) { // eslint-disable-line
  const expireDate = moment().add(5, 's').toDate();
  $cookiesProvider.defaults.expires = expireDate;
}
